export function getProfessionDisplayName(prof: string) {
  switch (prof) {
    case "SSK":
      return "Sjuksköterska";
    case "USK":
      return "Undersköterska";
    case "Medicinska sekreterare":
      return "Medicinsk Sekreterare";
    default:
      return prof;
  }
}

export function includesNationalProfession(professions: string[]) {
  return professions.some((prof) => NATIONAL.includes(prof as any));
}

export const NATIONAL = ["Läkare", "SSK", "Röntgensjuksköterska", "Barnmorska"] as const;
